module.exports = __webpack_public_path__ + "img/griss.b7c1b9a5.png";